var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64446 5.58947C2.99183 3.69474 4.25498 2.52632 5.86551 2.52632C6.84446 2.52632 7.9813 2.96842 9.08656 3.78947L9.81288 4.38947L10.5711 3.82105C11.6764 3 12.7816 2.58947 13.7602 2.58947C15.3708 2.58947 16.6339 3.75789 16.9813 5.58947C17.5813 8.68421 15.5918 12.8526 9.81288 15.3158C4.03393 12.8842 2.01288 8.71579 2.61288 5.58947H2.64446ZM0.14972 5.11579C-0.671333 9.28421 1.8234 14.8105 9.14972 17.7474C9.37109 17.8333 9.60698 17.8762 9.84446 17.8737C10.0819 17.8762 10.3178 17.8333 10.5392 17.7474C17.8342 14.7474 20.2971 9.25263 19.5076 5.08421C18.9076 2.02105 16.6655 0.0315789 13.7918 0.0315789C12.3878 0.0697895 11.0214 0.496421 9.84446 1.26316C8.66277 0.477789 7.28404 0.0404211 5.86551 0C3.0234 0.0315789 0.718141 2.08421 0.14972 5.11579Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.1c0b73cc.svg";
export { ForwardRef as ReactComponent };